import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { IframeContent } from './iframeContent.component';
import { selectLocalesLanguage } from '../../reducers/locales/locales.selectors';


const mapStateToProps = createStructuredSelector({
  currentLanguage: selectLocalesLanguage,
});

export const mapDispatchToProps = (dispatch) => bindActionCreators({ }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(IframeContent);
